import { Box, ButtonBase, CircularProgress, Stack, Typography, useTheme } from "@mui/material";
import { useEffect, type JSX } from "react";
import SortableTable from '@lib/utils/sortable-table';
import { type Artifact } from "@lib/models/Artifact";
import { type IArtifactService } from "@lib/services/interfaces/artifactService";
import { AttachFileTwoTone, FileDownloadOutlined, PictureAsPdf, SettingsOverscan } from "@mui/icons-material";
import { getServerBaseUrl } from "@lib/utils/environmentUtils";
import HtmlOutlinedIcon from '@mui/icons-material/HtmlOutlined';

interface ArtifactRenderProps {
  artifact?: Artifact | null;
  mode: 'full' | 'compact';
  isMobile: boolean;
  isTablet: boolean;
  preview: boolean;
  sessionId?: string;
  renderMode?: 'browser' | 'serverside';
  naked: boolean;
  fullImage?: boolean;
  artifactService: IArtifactService
  onExpand?: (artifact: Artifact) => void
}

const ArtifactRender = ({ artifact, mode, sessionId, preview, onExpand, renderMode = 'browser', naked = false, fullImage = false }: ArtifactRenderProps): JSX.Element => {
  const theme = useTheme();
  // let state: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
  // let loadPromise: React.RefObject<Promise<string | null> | null> | null = null;

  // Image loading state for large images - only use hooks in browser mode
  let imageLoading = false;
  let setImageLoading: React.Dispatch<boolean> | null = null;
  //let stateImageLoading: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
  let imageError = false;
  let setImageError: React.Dispatch<boolean> | null = null;
  //let stateImageError: [boolean, React.Dispatch<React.SetStateAction<boolean>>];

  // if (renderMode === 'browser') {
  //   state = useState(false);
  //   isLoading = state[0];
  //   setIsLoading = state[1];
  //   loadPromise = useRef<Promise<string | null> | null>(null);

  //   stateImageLoading = useState(false);
  //   imageLoading = stateImageLoading[0];
  //   setImageLoading = stateImageLoading[1];
  //   stateImageError = useState(false);
  //   imageError = stateImageError[0];
  //   setImageError = stateImageError[1];
  // }


  // const getArtifactContent = async (id: string): Promise<string | null> => {
  //     if (!artifact)
  //         return Promise.resolve(null);

  //     if (loadPromise === null)
  //         return null;

  //     if (loadPromise.current)
  //         return loadPromise.current;

  //     loadPromise.current = FirebaseArtifactService.getFileContent(`${getArtifactsBaseUrl()}/${id}`)
  //         .then((content) => {
  //             loadPromise.current = null;
  //             return content;
  //         })

  //     return loadPromise.current;
  // }

  if (artifact && renderMode === 'browser') {
    useEffect(() => {
      if (artifact.mimeType == "text/html") {

        setTimeout(() => {
          const sortableTable = new SortableTable();
          console.warn("Making sortable", `container-table_${artifact?.id ?? 'idnull'}_${mode}_${naked}`)
          const container = document.getElementById(`container-table_${artifact?.id ?? 'idnull'}_${mode}_${naked}`);
          console.log("Container", container);
          if (container) {
            console.log("Initializing sortable table", container);
            sortableTable.init(container);
          }
          //setIsLoading(false);
        }, 400);
      }
    }, [artifact, preview, naked, mode]);
  }

  // const loadArtifactHtml = (): string | null => {
  //   if (artifact && artifact.mimeType == "text/html") {
  //     if (!artifact.html && artifact.dataAsString) {
  //       artifact.html = ArtifactHtmlHandler.handleArtifactHtml(artifact.dataAsString, mode, isMobile, theme);
  //       artifactService.saveArtifactToCache(artifact);
  //     }

  //     return artifact.html ?? null;
  //   }
  //   return null;
  // }

  function geticon(mimeType: string) {
    switch (mimeType) {
      case "text/html":
        return <HtmlOutlinedIcon fontSize="large" />
      case "text/csv":
        return <FileDownloadOutlined fontSize="large" />
      case "application/pdf":
        return <PictureAsPdf fontSize="large" />
      default:
        return <AttachFileTwoTone fontSize="large" />
    }
  }

  function getMimeTypeCard() {
    return <Box sx={{
      display: mode === 'compact' && naked === false ? 'flex' : 'block',
      textAlign: 'center',
      alignContent: 'center',
      justifyContent: 'center',
      boxSizing: mode === 'compact' && naked === false ? 'border-box' : 'auto',
      maxWidth: '100%',
      maxHeight: renderMode == 'browser' && naked && !fullImage && mode == 'compact' ?
        '100%' :
        renderMode == 'serverside' ? 'unset' : '100%',
      width: '100%',
      height: mode === 'compact' ? '300px' : '100%',
      margin: mode === 'compact' ? '5px auto' : '0px',
      padding: '15px 5px',
      minWidth: mode === 'compact' ?
        renderMode == 'browser' ? '100%' : '300px'
        : '300px',
      backgroundColor: theme.palette.background.default,
      borderRadius: '10px',
      border: `1px solid ${theme.palette.divider}`,
      overflow: mode === 'compact' ? 'hidden' : 'auto',
      position: 'relative', // For overlay positioning                   
    }}>
      {geticon(artifact?.mimeType ?? '')}
      <Typography variant="h4" color="text.secondary" align="center">
        {artifact?.name}
      </Typography>
    </Box>
  }

  function getHtmlContent(_html: string, isLoading: boolean) {
    return isLoading ?
      <Box sx={{
        display: mode === 'compact' && naked === false ? 'flex' : 'block',
        textAlign: 'center',
        justifyContent: mode === 'compact' ? 'center' : 'auto',
        boxSizing: mode === 'compact' && naked === false ? 'border-box' : 'auto',
        maxWidth: '100%',
        maxHeight: renderMode == 'browser' && naked && !fullImage && mode == 'compact' ?
          '100%' :
          renderMode == 'serverside' ? 'unset' : '100%',
        width: '100%',
        height: mode === 'compact' ? 'auto' : '100%',
        margin: mode === 'compact' ? '5px auto' : '0px',
        padding: '15px 5px',
        minWidth: mode === 'compact' ?
          renderMode == 'browser' ? '100%' : '300px'
          : '300px',
        backgroundColor: theme.palette.background.default,
        borderRadius: '10px',
        border: `1px solid ${theme.palette.divider}`,
        overflow: mode === 'compact' ? 'hidden' : 'auto',
        position: 'relative', // For overlay positioning               
      }}>
        <Stack direction="row" gap={2} alignItems={"center"}>
          <CircularProgress size={60} />
          <Typography variant="h4" color="text.secondary" align="center">
            Loading...
          </Typography>
        </Stack>
      </Box>
      :
      artifact?.src ? (<div className="iframe-container">
        <iframe src={`${artifact?.src}`} style={{ minHeight: '80vh', width: '100%', borderRadius: 'var(--radius-md)' }} />
      </div>)
        :
        (<div id={`container-table_${artifact?.id ?? 'idnull'}_${mode}_${naked}`}>
          <div dangerouslySetInnerHTML={{ __html: artifact?.html ?? '' }} />
        </div>)
  }

  function getEmbbedImage(artifact: Artifact) {
    const artifactLabel = artifact.description ?? "";
    const imageUrl = artifact.name?.indexOf("http") == -1 ? `${getServerBaseUrl()}/open/getImage/${sessionId}/${artifact.name}` : artifact.name;

    const handleImageLoad = () => {
      if (renderMode === 'browser' && setImageLoading && setImageError) {
        setImageLoading(false);
        setImageError(false);
      }
    };

    const handleImageError = () => {
      if (renderMode === 'browser' && setImageLoading && setImageError) {
        setImageLoading(false);
        setImageError(true);
      }
    };

    return <Box sx={{
      display: mode === 'compact' && naked === false ? 'flex' : 'block',
      textAlign: 'center',
      justifyContent: mode === 'compact' ? 'center' : 'auto',
      boxSizing: mode === 'compact' && naked === false ? 'border-box' : 'auto',
      maxWidth: '100%',
      maxHeight: renderMode == 'browser' && naked && !fullImage && mode == 'compact' ?
        '100%' :
        renderMode == 'serverside' ? 'unset' : '100%',
      width: '100%',
      height: mode === 'compact' ? 'auto' : '100%',
      margin: mode === 'compact' ? '5px auto' : '0px',
      padding: '15px 5px',
      minWidth: mode === 'compact' ?
        renderMode == 'browser' ? '100%' : '300px'
        : '300px',
      backgroundColor: theme.palette.background.default,
      borderRadius: '10px',
      border: naked ?
        renderMode == 'browser' ? '1px solid' : 'none' :
        '1px solid',
      borderColor: 'divider',
      overflow: mode === 'compact' ? 'hidden' : 'auto',
      position: 'relative', // For overlay positioning
    }}>
      {
        renderMode === 'browser' && imageLoading && (
          <Box sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10,
            borderRadius: '10px',
          }}>
            <CircularProgress size={30} sx={{ color: 'text.secondary', mb: 2 }} />
            <Typography variant="body1" sx={{ color: 'text.secondary', textAlign: 'center' }}>
              Loading high-resolution image...
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary', textAlign: 'center', mt: 1 }}>
              Large images may take a moment to load
            </Typography>
          </Box>
        )
      }
      {
        naked && (
          <ButtonBase onClick={() => onExpand ? onExpand(artifact) : console.log("No subscriber")} sx={{
            position: "absolute", right: '0', top: '0', px: 1, py: 1, cursor: 'pointer',
            color: '#666666',
            "&:hover": {
              color: 'text.secondary'
            },
            "&:focus": {
              color: 'unset', border: '0x solid', borderRadius: 'unset', outline: 'none'
            },
            "&:active": {
              color: 'unset', border: '0x solid', borderRadius: 'unset', outline: 'none'
            },
          }}>
            <SettingsOverscan />
          </ButtonBase>
        )
      }

      {/* Error State - only show in browser mode */}
      {
        renderMode === 'browser' && imageError && (
          <Box sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10,
            borderRadius: '10px',
          }}>
            <Typography variant="h6" sx={{ color: 'white', mb: 1 }}>
              Failed to load image
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)', textAlign: 'center' }}>
              Please try refreshing or check your connection
            </Typography>
          </Box>
        )
      }

      {/* Image */}
      <img
        src={imageUrl}
        alt={artifactLabel ?? ''}
        style={{
          maxWidth: fullImage ? 'none' : renderMode == 'serverside' ? '100%' : '95%',
          maxHeight: fullImage ? 'none' : '100%',
          height: 'auto',
          width: 'auto',
          minWidth: mode === 'full' || renderMode == 'serverside' ? '450px' : 'none',
          minHeight: mode === 'full' || renderMode == 'serverside' ? '350px' : 'none',
          objectFit: mode === 'full' ? 'unset' : 'contain',
          opacity: (renderMode === 'browser' && imageLoading) ? 0 : 1, // Hide image while loading
        }}
        onLoad={renderMode === 'browser' ? handleImageLoad : undefined}
        onError={renderMode === 'browser' ? handleImageError : undefined}
      />
    </Box>
  }

  // if(artifact.dataAsString)
  //     setIsLoading(false)
  if (!artifact?.mimeType?.startsWith("image")) {
    if (preview)
      return getMimeTypeCard()
    else
      return getHtmlContent(artifact?.html ?? '', false)
  }
  else {
    return getEmbbedImage(artifact)
  }

  // return <div style={{ minWidth: '300px', minHeight: '400px', color: 'red' }}>LOADING</div>
}


export default ArtifactRender;